export const filter_types_list = [
  {
    label: 'Category',
    value: 'category',
  },
  {
    label: 'Sorting',
    value: 'sorting',
  },
  {
    label: 'Single Select Dropdown (Attribute)',
    value: 'single-select-attribute',
  },
  {
    label: 'Single Select Radio (Attribute)',
    value: 'single-select-radio-attribute',
  },
  {
    label: 'Nearest Area',
    value: 'nearest-area-search',
  },

  // {
  //   label: 'Multi Select (Attribute)',
  //   value: 'multi-select-attribute',
  // },
  // {
  //   label: 'Single Value (Attribute)',
  //   value: 'multi-value-attribute',
  // },
  // {
  //   label: 'Location (Attribute)',
  //   value: 'location-attribute',
  // },
  // {
  //   label: 'Date (Attribute)',
  //   value: 'date-attribute',
  // },
  {
    label: 'Date (Listing)',
    value: 'date-listing',
  },
  {
    label: 'Search Button',
    value: 'search-button',
  },
]
export const account_filter_types_list = [
  {
    label: 'Category',
    value: 'category',
  },
  // {
  //   label: 'Sorting',
  //   value: 'sorting',
  // },
  // {
  //   label: 'Single Select Dropdown (Attribute)',
  //   value: 'single-select-attribute',
  // },
  // {
  //   label: 'Single Select Radio (Attribute)',
  //   value: 'single-select-radio-attribute',
  // },

  {
    label: 'Search Button',
    value: 'search-button',
  },
]
